<template>
  <div class="contenido">
    <h2 class="pl-3">{{ father }} | Historial Alumno</h2>
    <v-card class="pa-3 ma-3">
      <v-card-title>
        <v-row align="center" justify="center">
          <v-col cols="4">
            <v-text-field
              v-model="dni"
              append-icon="mdi-magnify"
              label="Buscar por Dni"
              single-line
              hide-details
              @keypress="soloNumeros"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-title>
      <template v-if="cargando">
        <v-row justify="center" class="text-center">
          <v-col cols="12">
            <v-progress-circular :size="50" indeterminate color="purple"></v-progress-circular>
          </v-col>
        </v-row>
      </template>
      <template v-if="historial == '' || historial.length == 0">
        <v-row align="center" justify="center">
          <v-col cols="10" class="msj">
            <h3 class="text-center">No hay información para mostrar...</h3>
          </v-col>
        </v-row>
      </template>
      <template v-else>
        <v-row align="center" justify="center" class="datosAlumno">
          <v-col cols="12">
            <v-row align="center" justify="center">
              <v-col class="texto" cols="2">Alumno:</v-col>
              <v-col class="texto" cols="4">{{historial.nombre}}</v-col>
            </v-row>
            <v-row align-center justify-center>
              <v-col class="texto" cols="2">Dni:</v-col>
              <v-col class="texto" cols="4">{{historial.dni}}</v-col>
            </v-row>
            <v-row align-center justify-center>
              <v-col class="texto" cols="3">Agrupamiento:</v-col>
              <v-col class="texto" cols="4">{{historial.agruamiento}}</v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row justify="end">
          <v-col cols="4">
            <v-select
              :items="periodos"
              label="Seleccione Periodo"
              solo
              @change="aplicarFiltro($event)"
              clearable="true"
            ></v-select>
          </v-col>
        </v-row>
        <template v-for="(periodo, i) in historial.historial">
          <itemPeriodo
            :key="i"
            :periodo="periodo"
            :class="[filtro != '' && filtro !='Todos' && filtro != periodo.nombre? 'oculto' : '']"
          />
        </template>
      </template>
    </v-card>
  </div>
</template>

<script>
import API from "@/components/_config/conf";
import itemPeriodo from "./historial/itemPeriodo";

export default {
  data() {
    return {
      dni: "",
      cargando: false,
      historial: "",
      periodos: ["Todos"],
      filtro: ""
    };
  },
  components: {
    itemPeriodo
  },
  props: ["father"],
  mounted: function() {},
  methods: {
    /* ir(elem) {
      console.log(elem);
      let dir = elem;
      this.moverHacia = dir;
      //let options = { duration: 300, offset: 0, easing: "easeInOutCubic" };
      //this.$vuetify.goTo(dir, options);
      //console.log(this.$vuetify.goTo, dir);
    },*/
    aplicarFiltro(elem) {
      //console.log("aplicarFiltro: ", elem.value);
      this.filtro = elem;
    },
    soloNumeros(e) {
      this.historial = ""; //limpio historial

      var key = window.event ? e.which : e.keyCode;
      if (key < 48 || key > 57) {
        e.preventDefault();
      }
    },
    verificarDni: function() {
      if (this.dni.length >= 7) {
        this.obtenerHistorialAlumno();
      } else {
        this.historial = "";
        this.cargando = false;
      }
    },
    obtenerHistorialAlumno: function() {
      let params = "dni=" + this.dni;
      let resultado = API.enviar("get", "historicoAlumno", params);

      resultado
        .then(result => {
          if (result.data.msj == "ok") {
            this.historial = result.data.result;

            for (const periodo in this.historial.historial) {
              this.periodos.push(this.historial.historial[periodo].nombre);
            }

            this.cargando = false;
          } else {
            this.historial = "";
            this.cargando = false;
          }
        })
        .catch(() => {});
    }
  },
  watch: {
    dni: function() {
      this.cargando = true;
      this.verificarDni();
    },
    periodos: function() {
      //console.log(this.periodos);
    },
    filtroVacio: function() {
      //console.log("watch filtroVacio: ", this.filtroVacio);
    },
    filtro: function() {
      //console.log("watch filtro: ", this.filtro);
    }
  }
};
</script>

<style scoped>
h2 {
  text-align: left;
  margin-bottom: 10px;
}

.msj {
  padding: 30px;
}

.datosAlumno {
  padding: 30px 0 30px 0;
}

.texto {
  font-size: 18px;
  /*font-weight: bold;*/
}

.oculto {
  display: none;
}
</style>